import { Filter } from '../helpers/Filter';
import { Order } from '../helpers/Order';
import { Module } from '../Module';
import {
  GetDestinationProjectsRequest,
  IGetDestinationProjectsResult,
} from '../ServerApi/requests/GetDestinationProjectsRequest';
import { IDestinationProject } from '../ServerApi/types/IDestinationProject';
import { NamedItemKeys } from '../ServerApi/types/resourceParts';
import { FetcherFactory } from '../services/FetcherFactory';
import { Resource } from './Resource';
import { ResourceQuery } from './ResourceQuery';

export type DestinationProjectContentType = 'project' | 'workbook' | 'datasource' | 'flow' | 'dataRole';

export class DestinationProjects extends Resource<IDestinationProject> {
  public static $inject = ['FetcherFactory'];

  constructor(FetcherFactory: FetcherFactory) {
    super(FetcherFactory.getServerResourceFetcher(GetDestinationProjectsRequest,
      (result: IGetDestinationProjectsResult) => result.projects));
  }

  public getQueryForSpecificSourceContentAndMatchText(
    contentType: DestinationProjectContentType,
    sourceIds: string[],
    matchText: string
  ): ResourceQuery<IDestinationProject> {
    return this.all()
      .withExtraParams({ 'contentType': contentType, 'sourceIds': sourceIds })
      .withFiltersAndOrder([Filter.search(matchText)], [Order.asc(NamedItemKeys.name)]);
  }
}

Module.instance().service('DestinationProjects', DestinationProjects);
